"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainMenu = void 0;
const mainMenu = () => {
    const navToggle = (target, item, mega) => {
        const header = document.querySelector('.site-header');
        if (!mega.classList.contains('is-visible')) {
            item.querySelector('[data-toggle="nav"]').setAttribute('aria-expanded', 'true');
            item.classList.add('is-open');
            setTimeout(function () {
                header.classList.add('has-mega');
                mega.classList.add('is-visible');
            }, 100);
        }
        else {
            item.querySelector('[data-toggle="nav"]').setAttribute('aria-expanded', 'false');
            mega.classList.remove('is-visible');
            header.classList.remove('has-mega');
            setTimeout(function () {
                item.classList.remove('is-open');
            }, 250);
        }
        closeAll(target, item, mega);
    };
    const closeAll = (target, item, mega) => {
        const header = document.querySelector('.site-header');
        if (!header.classList.contains('has-mega'))
            return;
        let navItems = document.querySelectorAll('.main-menu__item');
        let navMegas = document.querySelectorAll('.main-menu__mega');
        for (let navItem of navItems) {
            if (navItem !== item) {
                navItem.classList.remove('is-open');
                let button = navItem.querySelector('button');
                if (button) {
                    button.setAttribute('aria-expanded', 'false');
                }
            }
        }
        for (let navMega of navMegas) {
            if (navMega !== mega) {
                navMega.classList.remove('is-visible');
            }
        }
        header.classList.remove('has-mega');
    };
    document.addEventListener('click', function (event) {
        const target = event.target;
        if (!target.matches('[data-toggle="nav"]'))
            return;
        const navItem = target.closest('.main-menu__item');
        const navMega = navItem.querySelector('.main-menu__mega');
        navToggle(target, navItem, navMega);
    }, false);
    document.addEventListener('click', function (event) {
        const target = event.target;
        if (target.matches('.site-header *'))
            return;
        closeAll(target, null, null);
    });
};
exports.mainMenu = mainMenu;
